export default __webpack_public_path__ + "static/media/rotate-left.68558ff2.svg";